export const launchPositions = [
  {
    left: 0,
    right: 0,
    margin: "0 auto"
  },
  {
    right: "20%"
  },
  {
    left: "20%"
  }
];
